// If this helper is needed in other parts of the application
// It should probably not be of the sportsbook, it could be in bv-helpers/sportsbook
// But for sure if isVirtual is called... the global sportsbook bundle is loaded
import { v as bvVar } from 'bv';

export default (sportEventPathId) => (
  bvVar('virtualSportsIds').includes(sportEventPathId)
);
